"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IkeSort = exports.IkeSortOrder = void 0;
exports.byKey = byKey;
var IkeSortOrder;
(function (IkeSortOrder) {
    IkeSortOrder[IkeSortOrder["ASC"] = 1] = "ASC";
    IkeSortOrder[IkeSortOrder["DESC"] = -1] = "DESC";
})(IkeSortOrder || (exports.IkeSortOrder = IkeSortOrder = {}));
function byKey(data, key, sortOrder) {
    let keys;
    if (!Array.isArray(key)) {
        keys = [key];
    }
    else {
        keys = key;
    }
    function compare(keyIndex, a, b) {
        const firstKey = keys[keyIndex];
        const keyA = a[firstKey];
        const keyB = b[firstKey];
        if (keyA === keyB) {
            if (keys.length - 1 > keyIndex) {
                return compare(keyIndex + 1, a, b);
            }
            return 0;
        }
        if (keyA > keyB) {
            return 1 * sortOrder;
        }
        return -1 * sortOrder;
    }
    return data.sort(compare.bind(null, 0));
}
exports.IkeSort = {
    DESC: IkeSortOrder.DESC,
    ASC: IkeSortOrder.ASC,
    Order: IkeSortOrder,
    byKey,
};
//# sourceMappingURL=sort.js.map